import React, {useEffect, useMemo, useState} from 'react'
import {observer} from 'mobx-react'
import {Box, Text} from '../../../../vanilla'
import {useBasketStore, useGlobalStore} from '../../../../store/hooks/useStore'
import {CalendarTabs} from './calendar-tabs'
import {TimeSlots} from './time-slots'


export const BookingSlotsContainer = () => {

  const {deliverySlots, deliverySlotArray, currentDeliverySlotId, isAppliedPostCodeDeliverable, sameDayDeliveryAvailable} =
  useBasketStore()

  const {setAndGetCustomPreferenceValueById} = useGlobalStore()

  const [smallBasketChargeEnabled, setSmallBasketChargeEnabled] = useState(false)

  const [selectedTab, setSelectedTab] = React.useState<number | undefined>()

  /** Handles default selected calendar tab once user already has booked a slot, but slot needs to rebooked  */
  useEffect(() => {
    if (!deliverySlotArray?.length || !currentDeliverySlotId) {
      return
    }

    ;(async function () {
      const chargeEnabled = await setAndGetCustomPreferenceValueById('SmallBasketChargeEnabled')
      setSmallBasketChargeEnabled(chargeEnabled === true)
    })()

    deliverySlotArray.forEach((deliverySlot, idx) => {
      for (const slot of deliverySlot.slots || []) {
        if (slot.id === currentDeliverySlotId) {
          setSelectedTab(idx)
          break
        }
      }
    })
  }, [deliverySlots, currentDeliverySlotId])

  const array = deliverySlotArray

  const availableDatesText = useMemo(() => {
    let text = ''
    if (array?.length) {
      const firstDay = array[0]
      const lastDay = array[array.length - 1]
      text = `${firstDay?.day} ${firstDay?.month} - ${lastDay?.day} ${lastDay?.month}`
    }
    return text
  }, [array])

  const datesAreAvailable = deliverySlots && isAppliedPostCodeDeliverable && availableDatesText.length

  // Check if same day slots are available, if not selects tomorrow
  useEffect(() => {
    if (!sameDayDeliveryAvailable) {
      setSelectedTab(1)
    }
  }, [sameDayDeliveryAvailable])

  return (
    <Box gridColumn="span 12" paddingBottom="12px">
      <Text
        style={{color: '#9b9b9b'}}
        variant="text6"
        marginTop={['8px', '20px']}
        paddingX={['16px', '0px']}
      >
        Available times:{' '}
        <Text
          as="span"
          color="black"
          variant={datesAreAvailable ? 'text7' : 'text3'}
        >
          {datesAreAvailable ? availableDatesText: 'No dates available'}
        </Text>
      </Text>
      {isAppliedPostCodeDeliverable ? (
        <>
          {deliverySlots && (
            <CalendarTabs setSelectedTab={setSelectedTab} selectedTab={selectedTab} />
          )}
          {deliverySlots && <TimeSlots selectedTab={selectedTab} smallBasketEnabled={smallBasketChargeEnabled} />}
        </>
      ) : null}
      {smallBasketChargeEnabled ? ( 
        <Text>
          *Small basket fee may apply
        </Text>
      ) : null}
    </Box>
  )
}

export const BookingSlots = observer(BookingSlotsContainer)
